// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__tsKVB","colMaxWidth":"Table_colMaxWidth__23Ndp"};